/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementDeleteEventResponse } from './EventManagementDeleteEventResponse';

export type EventManagementDeleteEventResponseApiRespoonse = {
    data?: EventManagementDeleteEventResponse;
    status?: EventManagementDeleteEventResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventManagementDeleteEventResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

